import React, { useState, useEffect } from 'react';
import { Colors, Spacing, Typography } from '_styles';
// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectScreen, selectScreenStatus, setScreen } from '_redux/slices/main-screen/render-screen';
import { selectLock } from '_redux/slices/main-screen/screen-lock';
import { setString, setWarning } from '_redux/slices/main-screen/warning-modal';

const SidebarIcon = (props) => {

    // redux
    const dispatch = useDispatch();
    const selectedPage = useSelector(selectScreen);
    const screenLock = useSelector(selectLock);

    // toggle mouse over
    const [toggle, setToggle] = useState(false);        

    // handle icon press
    const handlePress = (page) => {
        if(screenLock == true){
            dispatch(setString(page))
            dispatch(setWarning(true))
        }
        else {
            dispatch(setScreen(page))
        }
    }

    return (
        <>
            
            <div 
            style={{
                 alignText:'center', 
                 marginBottom:10, 
                 textAlign:'center', 
                 width:'100%', 
                 height:50, 
                 backgroundColor:toggle? '#4A8DE2' : Colors.PRM_LIGHT_BLUE, 
                 cursor:'pointer'
                 }} 
                 onClick={props.handleClick? props.handleClick : () =>{handlePress(props.page)}} 
                 onMouseEnter={()=>{setToggle(true)}} 
                 onMouseLeave={()=>{setToggle(false)}}>
                {/* Icon */}
                {props.icon}
                {
                    selectedPage == props.page ?
                        <div style={{marginLeft:Spacing.SCALE_8, marginRight:Spacing.SCALE_8, marginTop:Spacing.SCALE_4, borderBottomStyle:'solid', borderBottomColor:'white'}} />
                        :
                        ""
                }
            </div>
        </>
    );
}

export default SidebarIcon;